export default __webpack_public_path__ + "static/media/firebase-plain.64b9d72c.svg";